<script>
import AnimationSpineBaseFunctions from "@/components/animation/animation-spine-base-functions";

export default {
  name: "AnimationSpineRewardFlyCustom",
  mixins: [AnimationSpineBaseFunctions],
  data() {
    return {
      json: null,
      atlas: null,
      targetElement: null,
      startElement: null,
      rewardResult: "",
    };
  },

  computed: {
    rewardType: function () {
      switch (this.rewardResult) {
        case "gold":
          return "gold";
        case "coin":
          return "gold";
        case "coins":
          return "gold";
        case "crown":
          return "crown";
        case "crowns":
          return "crown";
        case "card":
          return "card";
        case "cards":
          return "card";
        default:
          return null;
      }
    },

    containerId() {
      return "canvas-fly-custom-" + +Math.floor(Math.random() * 100);
    },
  },

  methods: {
    async playAnimationSpineRewardFlyDailyLogin(targetElement, rewardType) {
      if (!rewardType || rewardType === "elixir") return;

      this.rewardResult = rewardType;
      this.targetElement = targetElement;
      this.setAtlas();
      this.setJson();

      let containerElement = document.getElementById(this.containerId);
      if (containerElement) containerElement.remove();

      containerElement = document.createElement("div");
      containerElement.id = this.containerId;
      containerElement.style.opacity = 0;
      containerElement.classList.add("canvas-full-width");
      containerElement.style.width = window.innerWidth + "px";
      containerElement.style.height = window.innerHeight + "px";
      document.body.appendChild(containerElement);

      return new Promise((resolve) => {
        this.setupAnimation(
          "ani-fly",
          () => {
            this.onSuccess(containerElement);

            const state = this.spinePlayer.animationState;

            const listener = {
              complete: () => {
                state.removeListener(listener); // clean up
                resolve(); // ✅ Resolve when animation completes
              },
            };

            state.addListener(listener);
          },
          true
        );
      });
    },
    setJson() {
      switch (this.rewardType) {
        case "gold":
          this.json = "/assets/spines/reward-fly/skeleton-coinfly-main.json";
          break;
        case "card":
          this.json = "/assets/spines/reward-fly/skeleton-cardfly-main.json";
          break;
        case "crown":
          this.json = "/assets/spines/reward-fly/skeleton-crownfly-main.json";
          break;
        default:
          this.json = null;
      }
    },
    setAtlas() {
      switch (this.rewardType) {
        case "gold":
          this.atlas = "/assets/spines/reward-fly/skeleton-coinfly-main.atlas";
          break;
        case "card":
          this.atlas = "/assets/spines/reward-fly/skeleton-cardfly-main.atlas";
          break;
        case "crown":
          this.atlas = "/assets/spines/reward-fly/skeleton-crownfly-main.atlas";
          break;
        default:
          this.atlas = null;
      }
    },
    onSuccess(el) {
      this.spinePlayer.animationState.timeScale = 0.8;
      this.spinePlayer.animationState.setAnimation(0, "ani-fly", false);
      const canvas = this.spinePlayer.canvas;
      const skeleton = this.spinePlayer.skeleton;

      // Apply scaling to the skeleton (this scales all bones)
      const scaleFactor = 0.5;
      skeleton.scaleX = scaleFactor;
      skeleton.scaleY = scaleFactor;

      // Get canvas size
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Calculate the center of the canvas, adjusting for scaling
      const boneStart = skeleton.findBone("ctrl-start");
      boneStart.x = canvasWidth / 2 / scaleFactor; // Adjusted for scale
      boneStart.y = canvasHeight / 2 / scaleFactor; // Adjusted for scale

      // Calculate the target element's center position (adjusted for scale)
      const rect = this.targetElement.getBoundingClientRect();
      const canvasRect = canvas.getBoundingClientRect();

      // Calculate target position relative to the canvas, adjusted for scale
      const targetX =
        (rect.left + rect.width / 2 - canvasRect.left) / scaleFactor;
      const targetY =
        (canvasRect.height - (rect.top + rect.height / 2 - canvasRect.top)) /
        scaleFactor;

      // Set the bone end position to target (adjusted for scale)
      const boneEnd = skeleton.findBone("ctrl-end");
      boneEnd.x = targetX;
      boneEnd.y = targetY;

      // Update the skeleton's world transform
      skeleton.updateWorldTransform();
      el.style.opacity = 1;
    },
  },
};
</script>

<style lang="scss"></style>
